<!-- 考勤管理 -->
<template>
	<div class="fuzzy-matching-box">
		<div class="fuzzy-matching-top">
			<el-row class="top-first-line the-second-line">
				<el-col :span="5">
					<el-form-item label="学校:">
						<el-input v-model="Dform.schoolName" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="年级:">
						<el-input v-model="Dform.gradeName" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="班级:">
						<el-input v-model="Dform.className" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="RFID:">
						<el-input v-model="Dform.rfid" placeholder=''></el-input>
					</el-form-item>
				</el-col>

			</el-row>
			<el-row class="top-first-line the-second-line">
				<el-col :span="5">
					<el-form-item label="姓名:">
						<el-input v-model="Dform.studentName" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="学号:">
						<el-input v-model="Dform.studentNo" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="时间:">
						<el-date-picker v-model="Dform.startTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
							value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
						</el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="To:">
						<el-date-picker v-model="Dform.endTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
							value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
						</el-date-picker>
					</el-form-item>
				</el-col>

				<el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
			</el-row>
		</div>
		<div class="fuzzy-matching-bottom">
			<el-row class="list">
				<el-table stripe :border="true" v-loading="loading"
					:header-cell-style="{background:'#EDF6FF',color:'#000',}" ref="multipleTable" :data="tableData"
					tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column prop="rfidDecimal" label="RFID">
					</el-table-column>
					<el-table-column prop="studentName" label="姓名">
					</el-table-column>
					<el-table-column prop="studentNo" label='学号'>
					</el-table-column>
					<el-table-column prop="schoolName" label="学校">
					</el-table-column>
					<el-table-column prop="gradeName" label="年级">
					</el-table-column>
					<el-table-column prop="className" label="班级">
					</el-table-column>
					<el-table-column prop="status" label="考勤状态">
						<template #default="scope">
							<span v-if="scope.row.status == 0">{{'进校'}}</span>
							<span v-if="scope.row.status == 1">{{'出校'}}</span>
							<span v-if="scope.row.status == 6">{{'异常'}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="time" label="打卡时间">
					</el-table-column>
					
					<el-table-column prop="attendancePic" label="打卡照片" width="150">
						<template #default="scope">
							<img class="head_img"  src="../../../images/defult_man.jpeg" alt="" v-if="scope.row.attendancePic == null">
							<img class="head_img" :src="scope.row.attendancePic" alt="" @click="lookImage(scope.row.attendancePic)" v-else>
						</template>
					</el-table-column>
					
					<el-table-column label="操作" min-width="100">
						<template #default="scope">
							<el-button type="text" size="small" class="shanchuBtn"
								@click="deleteClick(scope.row)">删除</el-button>
						</template>
					</el-table-column>

				</el-table>

				<div class="block-fenye">
					<el-pagination :small="small" :disabled="disabled" :background="background"
						layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
						@current-change="handleCurrentChange" />
				</div>
			</el-row>
		</div>
		
		<ImageView v-if="imageView" @addClick="addClick" :titleValue="titleValue" :pathPic="pathPic" />
	</div>
</template>

<script>
	import { attendanceList, attendanceDelete } from '@/assets/api/schoollog';
	import ImageView from './ImageView.vue'
	
	export default {
		components: {
			ImageView
		},
		data() {
			return {
				loading: true,
				Dform: {
					className: "",
					rfid: "",
					gradeName: "",
					schoolName: "",
					studentName: "",
					studentNo: "",
					startTime: "",
					endTime: "",
				},
				total: '',
				pageInfo: {
					pageSize: "10",
					page: "1",
				},
				tableData: [],
				titleValue: '',
				imageView:false,
				pathPic:""
			};
		},
		created() {
			this.attendanceListSearch()
		},
		mounted() {

		},
		methods: {
			//删除
			deleteClick(item) {
				attendanceDelete(item.attendanceId).then((res) => {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.attendanceListSearch()
				}).catch((err) => {
					console.log(err);
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				})
			},
			//列表
			attendanceListSearch() {
				const params = {
					className: this.Dform.className,
					rfidDecimal: this.Dform.rfid,
					gradeName: this.Dform.gradeName,
					schoolName: this.Dform.schoolName,
					studentName: this.Dform.studentName,
					studentNo: this.Dform.studentNo,
					startTime: this.Dform.startTime,
					endTime: this.Dform.endTime,
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize,
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				attendanceList(params).then((res) => {
					console.log(res, '');
					this.tableData = res.data.data.list
					this.total = res.data.data.total
					this.loading = false

				}).catch((err) => {
					console.log(err, '');

				})
			},
			//查询
			entrylogClick() {
				this.attendanceListSearch()
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageInfo.page = val
				this.attendanceListSearch()
			},
			
			lookImage(file){
				this.pathPic = file;
				this.titleValue="考勤照片";
				this.imageView = true;
			},
			
			addClick() {
				this.imageView = false
			},
		},
	};
</script>

<style scoped lang="scss">
	.fuzzy-matching-box {
		padding-top: 20px;
		// overflow: hidden;
		// overflow: auto;
		width: 100%;
		height: 96%;
		background-color: #fff;
		border-radius: 8px;

		.title-top {
			padding: 20px 20px;
		}

		.fuzzy-matching-top {
			height: 130px;
			background-color: #fff;
			border-radius: 8px;
			
			

			.top-first-line {

				// justify-content: center 
				// justify-content: space-between
				//   justify-content: space-around;
				/deep/ {
					.el-form-item--small .el-form-item__label {
						// background-color: red;
						font-size: 16px;
					}

					.el-select--small {
						width: 100%
					}

					.el-form-item--small .el-form-item__label {
						width: 110px;
						text-align: right;
						height: 35px;
						line-height: 35px;
					}

					.el-input {
						width: 100%;
						height: 35px;
					}
				}
			}

			.the-second-line {
				margin-top: 15px;
				position: relative;

				.query-button {
					position: absolute;
					right: 150px;
					padding: 16px 24px;
					// top: 50%;
					// transform: translate(0,-50%);
				}

			}

			/deep/ {
				.el-range-editor--small.el-input__wrapper {
					height: 35px;
					line-height: 35px;
				}
			}

		}

		.fuzzy-matching-bottom {
			// position: absolute;
			padding: 20px;
			
			.head_img{
				max-width: 30px;
				max-height: 60px;
				object-fit: cover;
			}

			.shanchuBtn {
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;
				color: red;
			}

			/deep/ {
				.el-table th.el-table__cell>.cell {
					height: 30px;
					line-height: 30px;
					text-align: center;
					font-size: 16px;
					font-weight: 700;
				}

				.el-table td.el-table__cell div {
					text-align: center;
					// height: 200px;
					font-size: 16px;
					color: black;
				}

				.el-table:not(.el-table--border) .el-table__cell {
					// border: 0;
				}
			}

			.block-fenye {
				margin-left: 1000px;
				margin-top: 15px;
			}
		}

	}
</style>